// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';


export default function ReviewAgainDialog({ open, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Iconify icon={"eva:info-fill"} sx={{ width: 24, height: 24, color: 'info.main' }} />
        <Typography variant={smUp ? "h5" : "subtitle1"} gutterBottom>
          포지션을 수정하면, <br/>
          <DIOText/>가 공고를 다시 검토합니다.
        </Typography>
        <Typography variant={smUp ? "body1" : "body2" } sx={{ wordBreak: "keep-all" }} paragraph>
          세부 포지션을 수정하면 <b>매칭은 잠시 중단</b>되고, <br/>
          <b><DIOText/>의 승인 후 다시 시작</b>됩니다.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Button
          onClick={closeDialog}
          size="large"
          sx={{ px: 4 }}
          variant="contained"
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}
